module.exports = __webpack_public_path__ + "img/notice_220901_02.eb77719c.jpg";